type CurrencyMeta = {
  code: string;
  symbol: string;
  fractionDigits: number;
};

const currencyMap: Record<string, CurrencyMeta> = {
  CAD: { code: "CAD", symbol: "CA$", fractionDigits: 2 },
  USD: { code: "USD", symbol: "$", fractionDigits: 2 },
  INR: { code: "INR", symbol: "₹", fractionDigits: 2 },
  EURO: { code: "EUR", symbol: "€", fractionDigits: 2 },
  JPY: { code: "JPY", symbol: "¥", fractionDigits: 0 },
};

export const getCurrencyInfo = (currency?: string) => {
  if (!currency) {
    return { code: undefined, symbol: "", fractionDigits: 2 };
  }
  const normalized = currency.toUpperCase();
  const entry = currencyMap[normalized];

  if (entry) {
    return entry;
  }

  if (normalized === "MIXED") {
    return { code: "MIXED", symbol: "", fractionDigits: 2 };
  }

  return { code: normalized, symbol: normalized, fractionDigits: 2 };
};

export const formatCurrencyAmount = (amount: number | null | undefined, currency?: string) => {
  if (amount === null || amount === undefined) {
    return "";
  }
  const { code, symbol, fractionDigits } = getCurrencyInfo(currency);

  if (code && code !== "MIXED") {
    try {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: code,
        currencyDisplay: "symbol",
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      }).format(amount);
    } catch {
      // Fall back to manual formatting if Intl fails (e.g., unknown code)
    }
  }

  const safeAmount = typeof amount === "number" ? amount : Number(amount);
  const formatted = Number.isFinite(safeAmount) ? safeAmount.toFixed(Math.min(2, fractionDigits)) : "";
  return `${symbol}${formatted}`;
};
